import { Form } from "react-aria-components";
import { FormProvider, useForm } from "react-hook-form";

import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import { SubmitLink } from "./SubmitLink";
import { TextFieldController } from "./TextFieldController";

export const FormWrapper = () => {
	const methods = useForm({
		defaultValues: {
			firstName: "",
			lastName: "",
		},
		mode: "all",
	});

	return (
		<FormProvider {...methods}>
			<Form className="tw-flex tw-w-2/3 max-lg:tw-w-full">
				<fieldset className="tw-relative tw-flex tw-w-full tw-items-center tw-border-0 max-lg:tw-flex-col">
					<legend className="tw-sr-only">
						Please provide your first name and last name,
					</legend>
					<div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-4">
						<div className="tw-flex tw-w-full tw-gap-4 max-lg:tw-flex-col max-lg:tw-gap-4 max-md:tw-gap-3">
							<div className="tw-flex tw-grow max-lg:tw-flex-col max-lg:tw-gap-4 max-md:tw-gap-3">
								<TextFieldController
									name="firstName"
									inputMode="text"
									autoComplete="given-name"
									rules={{
										required: "Please enter your first name",
									}}
									placeholder="Enter First Name"
									label="First Name"
									className="tw-pr-2 max-lg:tw-pr-0"
								/>
								<TextFieldController
									name="lastName"
									inputMode="text"
									autoComplete="family-name"
									rules={{
										required: "Please enter your last name",
									}}
									placeholder="Enter Last Name"
									label="Last Name"
									className="tw-pl-2 max-lg:tw-pl-0"
								/>
							</div>
							<SubmitLink aria-label="Start search in BeenVerified">
								Start Search
							</SubmitLink>
						</div>
						<div className="tw-flex tw-w-full tw-items-center tw-gap-4 max-sm:tw-flex-col max-sm:tw-items-center max-sm:tw-gap-2">
							<div className="tw-grow tw-text-sm tw-font-medium tw-leading-6 tw-text-[#22293A] max-sm:tw-text-center">
								1,000,000+ people have tried BeenVerified.
							</div>
							<BaseCompanyLogo
								classNames={{
									picture: "tw-w-[144px] tw-h-6 tw-shrink-0",
									image:
										"tw-h-full tw-w-[115%] tw-object-[-10px] tw-object-cover",
								}}
							/>
						</div>
					</div>
				</fieldset>
			</Form>
		</FormProvider>
	);
};
